import { component as defineComponent } from 'flightjs';

function collapsible() {
    this.attributes({
        triggerSelector: '[data-collapsible-trigger]',
        toggleAttribute: 'data-collapsible-collapsed',
    });

    this.after('initialize', function() {
        this.on('click', {
            triggerSelector: this.toggleCollapse,
        });
    });

    this.toggleCollapse = function() {
        if (this.isCollapsed()) {
            this.$node.removeAttr(this.attr.toggleAttribute);
        } else {
            this.$node.attr(this.attr.toggleAttribute, true);
        }
    };

    this.isCollapsed = function() {
        return this.$node[0].hasAttribute(this.attr.toggleAttribute);
    };
}

export default defineComponent(collapsible);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/collapsible.js